/* eslint consumerweb/require-pagename:0 */
// This allows us to make styled React components that can
// either use <Link /> or <a /> based on whether they
// provide a `to` prop.
import PropTypes from 'prop-types'

import React from 'react'
import { Link } from 'react-router-dom'
import glamorous from 'glamorous'

// this creates a glamorousComponentFactory
// for the react-router Link component
// with all the configuration needed
function ConditionalLink(props) {
  if (props.to) {
    return <Link {...props} />
  }
  // eslint-disable-next-line react/prop-types
  return <a {...props}>{props.children}</a>
}
ConditionalLink.propTypes = {
  to: PropTypes.string,
}

const glamorousLink = glamorous(ConditionalLink, {
  rootEl: 'a',
  displayName: 'glamorous(RouterLink)',
  forwardProps: [
    'to',
    'query',
    'hash',
    'state',
    'activeClassName',
    'activeStyle',
    'onlyActiveOnIndex',
  ],
})

export default glamorousLink
